import { Routes } from '@angular/router';
import { AdminGuard } from '../../core/guards/admin.guard';

export const trafficMetricsRoutes: Routes = [
  {
    path: '',
    canActivate: [AdminGuard],
    loadComponent: () =>
      import('./components/traffic-monitoring-shell/traffic-monitoring-shell.component').then(
        (m) => m.TrafficMonitoringShellComponent,
      ),
    data: { title: 'Traffic Monitoring', breadcrumb: 'Traffic Monitoring' },
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        loadComponent: () =>
          import('./components/traffic-dashboard/traffic-dashboard.component').then(
            (m) => m.TrafficDashboardComponent,
          ),
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./components/traffic-events-page/traffic-events-page.component').then(
            (m) => m.TrafficEventsPageComponent,
          ),
      },
      {
        path: 'events/:id',
        loadComponent: () =>
          import('./components/traffic-event-detail-page/traffic-event-detail-page.component').then(
            (m) => m.TrafficEventDetailPageComponent,
          ),
      },
      {
        path: 'abuse',
        loadComponent: () =>
          import('./components/abuse-reports-page/abuse-reports-page.component').then(
            (m) => m.AbuseReportsPageComponent,
          ),
      },
      {
        path: 'abuse/:id',
        loadComponent: () =>
          import('./components/abuse-report-detail-page/abuse-report-detail-page.component').then(
            (m) => m.AbuseReportDetailPageComponent,
          ),
      },
      {
        path: 'blocklist',
        loadComponent: () =>
          import('./components/blocklist-page/blocklist-page.component').then(
            (m) => m.BlocklistPageComponent,
          ),
      },
    ],
  },
];
